package fr.frux.feature.onboarding

import androidx.compose.runtime.Composable

@Composable
internal actual fun OnboardingBackHandler(
    enabled: Boolean,
    onBack: () -> Unit,
) = Unit
